<template>
  <div class="container">
    <a-breadcrumb>
      <a-breadcrumb-item><a @click="goBack">抽奖活动管理</a></a-breadcrumb-item>
      <a-breadcrumb-item>中奖记录编辑</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="title">
      <h2>活动名称</h2>
      <span>活动类型：转盘</span>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      bordered
    >
      <template #bodyCell="{ column,index, record }">
        <template v-if="column.key === 'id'">
          <a-input v-model:value="record.id" allowClear />
        </template>
        <template v-if="column.key === 'name'">
          <a-select
            v-model:value="record.name"
            style="width: 100%;"
            placeholder="请选择"
          >
            <a-select-option value="jack">Jack</a-select-option>
            <a-select-option value="xxx">xxx</a-select-option>
          </a-select>
        </template>
        <template v-if="column.key === 'action'">
          <a-button type="link" @click="handleDelete(index)">删除</a-button>
        </template>
      </template>
    </a-table>
    <a-button class="btn" type="dashed" block @click="handleAddRecord">
      <PlusOutlined /> 添加数据
    </a-button>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  name: 'EditRecord',
  components: { PlusOutlined },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      dataSource: [
        { id: 1, name: 'xxx' },
        { id: 2, name: 'xxx' },
        { id: 3, name: 'xxx' }
      ],
      columns: [
        { title: '用户名', dataIndex: 'id', key: 'id', width: '50%' },
        { title: '获得奖项', dataIndex: 'name', key: 'name', width: '50%' },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 80,
          alias: 'left'
        }
      ],
      handleAddRecord() {
        state.dataSource.push({ id: state.dataSource.length, name: '' })
      },
      handleDelete(index) {
        state.dataSource.splice(index, 1)
      },
      goBack() {
        const query = route.query
        router.push({ name: 'List', query: { ...query } })
      }
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  padding: 24px;
  .title {
    margin: 16px 0;
  }
  .btn {
    margin-top: 16px;
  }
  .ant-btn {
    padding: 0;
  }
}
</style>
